import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/tooltip';

const loadTooltip = () => {
  $('[data-toggle="tooltip"]').tooltip();
};

export default loadTooltip;
